<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-AI`]" width="1em" height="1em" v-bind="$attrs"><path d="M23.001,8L18,8C17.171599999999998,8,16.5,7.32843,16.5,6.5C16.5,5.671573,17.171599999999998,5,18,5L30,5C30.8284,5,31.5,5.671573,31.5,6.5C31.5,7.32843,30.8284,8,30,8L26.001,8L26.001,10.5L36,10.5Q37.864,10.5,39.182,11.81802Q40.5,13.13604,40.5,15L40.5,37Q40.5,38.864,39.182,40.182Q37.864,41.5,36,41.5L12,41.5Q10.13604,41.5,8.81802,40.182Q7.5,38.864,7.5,37L7.5,15Q7.5,13.13604,8.81802,11.81802Q10.13604,10.5,12,10.5L23.001,10.5L23.001,8ZM10.93934,38.0607Q10.5,37.6213,10.5,37L10.5,15Q10.5,14.37868,10.93934,13.93934Q11.37868,13.5,12,13.5L36,13.5Q36.6213,13.5,37.0607,13.93934Q37.5,14.37868,37.5,15L37.5,37Q37.5,37.6213,37.0607,38.0607Q36.6213,38.5,36,38.5L12,38.5Q11.37868,38.5,10.93934,38.0607ZM2,32L2,21C2,20.171599999999998,2.671573,19.5,3.5,19.5C4.32843,19.5,5,20.171599999999998,5,21L5,32C5,32.8284,4.32843,33.5,3.5,33.5C2.671573,33.5,2,32.8284,2,32ZM43.001,32L43.001,21C43.001,20.171599999999998,43.6726,19.5,44.501,19.5C45.3294,19.5,46.001,20.171599999999998,46.001,21L46.001,32C46.001,32.8284,45.3294,33.5,44.501,33.5C43.6726,33.5,43.001,32.8284,43.001,32ZM21,29L16,29L16,24L21,24L21,29ZM27,29L27,24L32,24L32,29L27,29Z" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconAI',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
